export default __webpack_public_path__ + "static/media/no_photo.58b8abe5.jpg";